import styled from "styled-components";
import theme from "../../styles/theme";

const PageWrapper = styled.div`
  position: relative;
  padding-left: ${theme.unit}px;
  padding-right: ${theme.unit}px;

  @media (min-width: ${theme.mediaQueries.tablet}px) {
    display: flex;
    flex-direction: row;
    width: 100%;
    max-width: 1140px;
    margin: 0px auto;
  }

  @media (max-width: ${theme.mediaQueries.mobile}px) {
    .sidebar {
      display: none;
    }
  }
`;

export default PageWrapper;
